import { createUseStyles } from "react-jss";
//import { apaTheme } from "../../constants/theme";

export const useStyles = () => {
  return createUseStyles({
    selectedRowWrapper: {
      position: "absolute",
      right: 0,
      top: "50%",
      transform: "translateY(-50%)",
      display: "flex",
      background: "white",
      padding: "4px 8px",
      borderRadius: 4,
      zIndex: 1,
    },
    tableContainer: {
      backgroundColor: "white",
    },
    tableHead: {
      color: "#101828",
      fontWeight: 700
    },
  })();
};
